export class OidcConfigProvider {
  get(key) {
    const accessTokenValidityMs = 300000; // 5 min
    return new Map([
      [
        'awp-test.bmwgroup.com',
        {
          clientId: '5e951ade-821f-434d-af06-c62cae74d713',
          realm: 'alpha',
          wenEnvironment: 'emea.int.alpha.sso.bmwgroup.com',
          accessTokenValidityMs: accessTokenValidityMs,
          acr_values: 'strongAuth4000Service'
        }
      ]
    ]).get(key);
  }
}
